<template>
  <v-carousel cycle hide-delimiter-background show-arrows-on-hover v-if="slides.length > 0" light>
    <v-carousel-item v-for="(slide, i) in slides" :key="i">
      <v-img :src="path + '?id=' + slide.ruta" contain max-height="100%" max-width="100%"></v-img>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Publicidad",
  data() {
    return {
      path: process.env.VUE_APP_BASE_PATH + `/api/config/GetPublicidad`,
      slides: []
    };
  },
  computed: {
    ...mapGetters(["getToken"])
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  async created() {
    let respuesta;
    try {
      respuesta = await axios.get(
        process.env.VUE_APP_BASE_PATH + `/api/config/ListarPublicidad`,
        {
          headers: { Authorization: `Bearer ${this.getToken}` }
        }
      );
    } catch (error) {

      if (error.response.status == 400) {
        this.showAlerta2({
          mensaje: error.response.data.error_description,
          tipo: 3
        });
        //   } else {
        //     this.salir();
      }
      return;
    }
    if (Array.isArray(respuesta.data)) {
      this.slides = respuesta.data;
    } else {
      this.slides = [];
    }

  }
};
</script>
